import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { useDrop } from 'react-dnd';
import i18n from '@/locales/init'; 
import style from './index.module.less';

interface propsType {
  children: React.ReactNode; 
  show: boolean;
  style?: {display: string;};
  className?: string;
  scrollViewClass?: string;
}

export default function ScrollBody(props: propsType) {
  const {style: wrapStyle, className, scrollViewClass} = props;
  const scrollRef = useRef<HTMLDivElement|null>(null);
  const scrollTimer = useRef<number|NodeJS.Timeout>();
  const accepts = ['subTitle', 'subBlank', 'matchTitle', 'matchBlank', 'dependentPairingTitle', 'dependentPairingBlank', 'sentencePairingOption', 'sentencePairingBlank', 'summaryOption', 'summaryBlank'];

  const [{ isOver: isTopOver, canDrop: canTopDrop }, dropTop] = useDrop({
    accept: accepts,
    drop: () => {},
    collect: (monitor) => ({
      isOver: monitor.isOver({shallow: true}),
      canDrop: monitor.canDrop(),
    }),
  });

  const [{ isOver: isBottomOver, canDrop: canBottomDrop }, dropBottom] = useDrop({
    accept: accepts,
    drop: () => {},
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const [showDrag, setShowDrag] = useState<boolean>(false);

  useEffect(() => {
    setShowDrag(canTopDrop || canBottomDrop);
  }, [canTopDrop, canBottomDrop]);

  useEffect(() => {
    
    if (isTopOver) {
      console.log('开启定时器top');
      scrollTimer.current = setInterval(() => {
        console.log('scrollTimer.current.top', isTopOver);
        if (isTopOver && scrollRef.current) {
          scrollRef.current.scrollTop -= 3;
        } else if (!isTopOver) {
          clearInterval(scrollTimer.current);
          scrollTimer.current = 0;
        }
      }, 20);
    }
    
    return () => {
      if (scrollTimer.current) {
        clearInterval(scrollTimer.current);
        scrollTimer.current = 0;
        console.log('清除定时器top');
      }
    };
  }, [isTopOver]);

  useEffect(() => {
    
    if (isBottomOver) {
      console.log('开启定时器bottom');
      scrollTimer.current = setInterval(() => {
        console.log('scrollTimer.current.bottom', isTopOver);
        if (isBottomOver && scrollRef.current) {
          scrollRef.current.scrollTop += 3;
        } else if (!isBottomOver) {
          clearInterval(scrollTimer.current);
          scrollTimer.current = 0;
        }
      }, 20);
    }

    return () => {
      if (scrollTimer.current) {
        clearInterval(scrollTimer.current);
        scrollTimer.current = 0;
        console.log('清除定时器bottom');
      }
    };
  }, [isBottomOver]);

  return (
    <div className={classNames(className, style.answerControl)} style={wrapStyle}>
      {showDrag ? <div data-exam-surface ref={dropTop} className={classNames(style.top)} data-disable>{i18n.t('common.dauyan_slip_here_scrollup')}</div> : null}
      <div className={classNames(style.ansewer, scrollViewClass)} ref={scrollRef} data-scroll={true}>
        {props.children}
      </div>
      {showDrag ? <div data-exam-surface ref={dropBottom} className={classNames(style.bottom)} data-disable>{i18n.t('common.dauyan_slip_here_scrolldown')}</div> : null}
    </div>
  );
}
